import {createRouter, createWebHistory} from 'vue-router';
import {getSession} from "@/libs/utils";

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import('@/views/Directory.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/directory/:keyword?',
		name: 'Directory',
		component: () => import('@/views/Directory.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/entry/:id',
		name: 'EntryDetail',
		component: () => import('@/views/EntryDetail.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/entry/:id?/save',
		name: 'EntryForm',
		component: () => import('@/views/EntryForm.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/family/create',
		name: 'FamilyCreate',
		props: {type: 'family'},
		component: () => import('@/views/EntryForm.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/staff/create',
		name: 'StaffCreate',
		props: {type: 'staff'},
		component: () => import('@/views/EntryForm.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/entries/submitted-for-review',
		name: 'EntrySubmittedForReview',
		component: () => import('@/views/EntrySubmittedForReview.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/start-login',
		name: 'StartLogin',
		component: () => import('@/views/StartLogin.vue'),
	},
	{
		path: '/redeem-login',
		name: 'RedeemLogin',
		component: () => import('@/views/RedeemLogin.vue'),
	},
	{
		path: '/logout',
		name: 'Logout',
		component: () => import('@/views/Logout.vue'),
	},
	{
		path: '/privacy',
		name: 'Privacy',
		component: () => import('@/views/Privacy.vue'),
	},
	{
		path: '/terms-of-service',
		name: 'Terms',
		component: () => import('@/views/TermsOfService.vue'),
	},
	{
		path: '/:catchAll(.*)',
		redirect: '/'
	}
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { top: 0 };
		}
	}
});

router.beforeEach((to, from, next) => {

	if (!to.meta?.requiresAuth) return next();

	let session = getSession();

	if (!session) return next({name: 'StartLogin'});

	if (to.meta?.requiresAdmin && session?.role !== 'admin') {
		return next({name: 'StartLogin'});
	}

	next()
})

export default router;